// utils/categories.js
const categories = [
    "Retail",
    "Restaurant",
    "Service",
    "Entertainment",
    "Travel",
    "Health & Wellness",
    "Education",
    "Technology",
    "Finance",
    "Real Estate",
    "Fashion",
    "Automotive",
    "Sports",
    "Non-Profit",
    "Other"
  ];
  
  export default categories;
  